import { type ToastProps } from '../../types'

const getToastDuration = (
  toast: Pick<ToastProps, 'actionButton' | 'type' | 'duration'>,
) => {
  switch (true) {
    case !!toast.duration:
      return toast.duration
    case !!toast.actionButton:
      return 7_000
    case toast.type === 'error':
      return 7_000
    case toast.type === 'loading':
      return 100_000 // could take any time, until we remove it manually
    default:
      return 5_000
  }
}

export default getToastDuration
